import { injectStrict } from "@/utils/utils";
import { calculationWorkerKey } from "@/plugins/calculationWorkerPlugin";

export const useCalculationWorker = () => {
  const { queryCalculation, cancelCalculations } =
    injectStrict(calculationWorkerKey);

  return {
    queryCalculation,
    cancelCalculations
  };
};
